module.exports = __webpack_public_path__ + "./assets/5-d79a62.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/5.bmp
// module id = 23
// module chunks = 0